<template>
  <div
    class="stage-container"
    :class="[stageType, {
      current: current,
      clear: isTableClear(table.name),
    }]"
    @click="selectStage()"
  >
    <div
      v-if="stageType === 'single'"
      class="land level-clear-progress"
    >
      <img
        class="island"
        :src="$image(`normal/buttons/decoration/island-small.svg`)"
        :alt="table.title + 'のだん'"
      />
      <div :class="['land', { left }]">
        <MpEffectGetItem :name="`${table.name}-level1`">
          <img
            v-if="isClearedLevel(1)"
            class="perm_tree_small"
            :src="$image(`normal/buttons/decoration/palm_tree-small.svg`)"
            alt=""
          />
        </MpEffectGetItem>
        <MpEffectGetItem :name="`${table.name}-level2`">
          <img
            v-if="isClearedLevel(2)"
            class="perm_tree_large"
            :src="$image(`normal/buttons/decoration/palm_tree-large.svg`)"
            alt=""
          />
        </MpEffectGetItem>
        <MpEffectGetItem :name="`${table.name}-level3`">
          <img
            v-if="isClearedLevel(3)"
            class="perm_tree_large"
            :src="$image(`normal/buttons/decoration/palm_tree_with_fruits-large.svg`)"
            alt=""
          />
        </MpEffectGetItem>
        <MpEffectGetItem :name="`${table.name}-level4`">
          <img
            v-if="isClearedLevel(4)"
            class="hibiscus hibiscus1"
            :src="$image(`normal/buttons/decoration/hibiscus.svg`)"
            alt=""
          />
        </MpEffectGetItem>
        <MpEffectGetItem :name="`${table.name}-level5`">
          <img
            v-if="isClearedLevel(5)"
            class="hibiscus hibiscus2"
            :src="$image(`normal/buttons/decoration/hibiscus.svg`)"
            alt=""
          />
        </MpEffectGetItem>
        <MpEffectGetItem :name="`${table.name}-level6`">
          <img
            v-if="isClearedLevel(6)"
            class="hibiscus hibiscus3"
            :src="$image(`normal/buttons/decoration/hibiscus.svg`)"
            alt=""
          />
        </MpEffectGetItem>
        <MpHermitCrab
          v-show="isReached"
          class="hermit_crab"
          type="a"
        />
      </div>
    </div>
    <div
      v-if="stageType === 'multi'"
      class="level-clear-progress"
    >
      <img class="coral" :src="$image(coral)" alt="">
    </div>
    <img v-if="stageType === 'single'" class="shadow" :src="$image('normal/buttons/decoration/island-small-shadow.svg')" alt="">
    <img
      v-if="stageType === 'single'"
      class="button"
      :class="{ glow }"
      :src="$image(`normal/buttons/times_table-${table.title}.svg`)"
      alt=""
    />
    <img
      v-else
      class="button"
      :class="{ glow }"
      :src="multiStageButtonImage"
      alt=""
    >
    <img v-if="isCleared" class="check" :src="$image(`normal/buttons/decoration/checkmark-${stageType}.svg`)" alt="">
  </div>
</template>

<script>
import Normal from "@/mixins/normal";
import MpEffectGetItem from "./MpEffectGetItem.vue";
import MpHermitCrab from "./MpHermitCrab.vue";

export default {
  components: {
    MpEffectGetItem,
    MpHermitCrab,
  },
  mixins: [Normal],
  props: {
    table: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      required: false,
    },
    isCleared: {
      type: Boolean,
      required: false,
      default: false,
    },
    isReached: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearedPremise: {
      type: Boolean,
      required: false,
      default: false,
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    coral: {
      type: String,
      required: false,
    },
    glow: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    current() {
      return this.table.name == this.currentTable;
    },
    isIntroduction() {
      return (
        // 2の段の最初のみ案内ガイド開始
        this.table.times == 2 &&
        this.$store.getters["learningState/isIntroduction"]
      );
    },
    status() {
      return this.$store.state.learningState.normal[this.table.name];
    },
    stageType() {
      if (this.table.name.includes('to')) {
        return 'multi';
      }

      return 'single';
    },
    multiStageButtonImage() {
      return this.$image(`normal/buttons/times_table-${this.table.title.replace('〜', '–')}/button-${this.table.title.replace('〜', '–')}-${(this.clearedPremise) ? 'dark' : 'light'}.svg`);
    },
  },
  methods: {
    // ステージ選択
    selectStage() {
      // 画面ボタン操作イベント
      this.$store.dispatch("history/viewButtonEvent", {
        loginId: this.$store.getters["auth/getLoginId"],
        view: this.$store.getters["app/getCurrentView"],
        event: this.table.title + "のだん選択",
      });
      // テーブル選択
      this.$store.dispatch("app/selectTable", this.table.name);
      // ビュー変更
      this.$store.commit("app/setCurrentView", this.table.view);

      if (!this.isIntroduction) {
        // ２の段の最初でない場合

        // スタートガイド再生
        this.$sound.start(this.table.name).play();
      }
    },
    isClearedLevel(level) {
      return this.status[`level${level}`].clear > 0
    },
  },
};
</script>

<style lang="scss" scoped>
.stage-container {
  img.island {
    width: calc(var(--size-base) * 153);
    height: auto;
  }

  img.shadow {
    position: absolute;
    width: calc(var(--size-base) * 174);
    bottom: 32.04%;
    left: -3.2%;
  }

  .button {
    position: relative;
    z-index: var(--z-index-stage-button);
    width: calc(var(--size-base) * 160);

    transition: filter 0.3s;
    filter: drop-shadow(0px 0px calc(var(--size-base) * 10) transparent);

    &.glow {
      filter: drop-shadow(0px 0px calc(var(--size-base) * 10) #FFDE21);
    }
  }

  .check {
    position: absolute;
    top: -8%;
    right: -3.6%;
    z-index: var(--z-index-stage-button-decoration);
    width: calc(var(--size-base) * 36.18);
  }

  &.single {
    .level-clear-progress {
      cursor: pointer;
      position: absolute;
      bottom: 40%;
      left: 3%;
      width: calc(var(--size-base) * 153);
      height: calc(var(--size-base) * 162.45);

      .land {
        position: relative;
        width: calc(var(--size-base) * 153);
        height: calc(var(--size-base) * 162.45);

        &.left {
          right: 22%;

          .hermit_crab {
            left: 89%;
          }
        }

        .perm_tree_small {
          position: absolute;
          width: calc(var(--size-base) * 46.97);
          transform: scale(-1, 1);
          top: 27%;
          left: 27%;
          z-index: var(--z-index-stage-illust-front);
        }

        .perm_tree_large {
          position: absolute;
          width: calc(var(--size-base) * 97.78);
          top: 0%;
          left: 30%;
          z-index: var(--z-index-stage-illust-front);
        }

        .hibiscus {
          position: absolute;
          width: calc(var(--size-base) * 35.78);
          z-index: var(--z-index-stage-illust-front);

          &.hibiscus1 {
            top: 42%;
            left: 28%;
          }
          &.hibiscus2 {
            top: 49%;
            left: 49%;
          }
          &.hibiscus3 {
            top: 42%;
            left: 70%;
          }
        }
      }
    }

    .island {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: var(--z-index-stage-illust-back);
    }

    .hermit_crab {
      position: absolute;
      width: calc(var(--size-base) * 71.48);
      top: 21%;
      left: -5%;
      z-index: var(--z-index-stage-illust-front);
    }
  }

  &.multi {
    flex-direction: row-reverse;
    align-items: flex-end;

    .button {
      width: calc(var(--size-base) * 150);
    }

    .level-clear-progress {
      position: absolute;
      bottom: 88%;
      left: 23%;
      z-index: var(--z-index-stage);

      .coral {
        width: calc(var(--size-base) * 75.67);
      }
    }
  }
}
</style>